// Test IDs for the auth feature (login, logout).
// Directive: keys are camelCase, values are kebab-case `<feature>-<element>`.

export const LOGIN = {
	container: 'login-container',
	usernameInput: 'login-username-input',
	passwordInput: 'login-password-input',
	submitButton: 'login-submit-button',
	errorMessage: 'login-error-message',
};

export const LOGOUT = {
	button: 'logout-button',
};
